import upDownRefresh from './activityIndicator.vue';
import partLoading from './partLoading.vue';
import uploading from './uploading.vue';
export default {
    upDownRefresh,
    partLoading,
    uploading,
};
